import { history } from '@umijs/max';
import { getAdminToken } from '@/services/admin-auth';

const loginPath = '/user/login';

// 公开路径，不需要认证
const publicPaths = ['/user/login', '/user/register', '/user/register-result'];

/**
 * 检查当前路由是否为管理员路由（整个管理端都需要认证）
 */
export const isAdminRoute = (pathname: string): boolean => {
  // 整个管理端都需要管理员认证，除了公开路径
  return !publicPaths.includes(pathname);
};

/**
 * 检查管理员是否已登录
 */
export const isAdminLoggedIn = (): boolean => {
  return !!getAdminToken();
};

/**
 * 路由守卫：检查管理员权限
 */
export const checkAdminAuth = (pathname: string): void => {
  const isPublicPath = publicPaths.includes(pathname);
  const isLoginPage = pathname === loginPath;

  // 如果不是公开路径，需要检查登录状态
  if (!isPublicPath && !isAdminLoggedIn()) {
    history.push(loginPath);
    return;
  }

  // 如果已登录访问登录页，重定向到首页
  if (isLoginPage && isAdminLoggedIn()) {
    history.push('/dashboard/analysis');
  }
};

/**
 * 导出登出函数
 */
export const adminLogout = (): void => {
  const { clearAdminToken } = require('@/services/admin-auth');
  clearAdminToken();
  history.push(loginPath);
};
